import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    selectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: 6,
    },
    select: {
        backgroundColor: theme.palette.primary.main,
        "& fieldset": {
            borderColor: theme.palette.border.select,
        },
        "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            "&.MuiInputBase-input": {
                flexDirection: "column",
                alignItems: "self-start",
            },
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.primary.darker,
            fontFamily: "Source Sans 3",
            padding: "9px 12px",
        },
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
        gap: 4,
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    smallSelect: {
        "& .MuiSelect-select": {
            padding: "2px 12px !important",
            fontSize: 12,
        },
    },
    smallLabel: {
        fontSize: 10,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: 6,
    },
    menuItemLeftContent: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
}));

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: "300px",
        },
    },
};
